import { parseTemplate } from 'url-template';
import { formatApiDate } from '~/Api/DateTime';
import { ErrorResponse } from '~/Api/User/ProductGroup/LtMaxPrice/ErrorResponse';
import { LtMaxPrice } from '~/Api/User/ProductGroup/LtMaxPrice/LtMaxPrice';
import { mapLtMaxPrice } from '~/Api/User/ProductGroup/LtMaxPrice/mapLtMaxPrice';
import { Update } from '~/Api/User/ProductGroup/LtMaxPrice/Update';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

export interface Result {
	ltMaxPrice: LtMaxPrice;
}

export const updateLtMaxPrice = async (
	client: ApiClient,
	userId: string,
	groupId: string,
	update: Update
): Promise<Result> => {
	const url = parseTemplate('users/{userId}/product-groups/{groupId}/lt-max-price');

	try {
		const request = await client.fetch(url.expand({ userId, groupId }), {
			body: JSON.stringify({
				products: update.products.map((product) => ({
					dosageStrengthForCalculation: product.dosageStrengthForCalculation,
					id: product.id,
					packageSizeForCalculation: product.packageSizeForCalculation,
					packageSizeForSingleUnit: product.packageSizeForSingleUnit,
					priceTypeForCalculation: product.priceTypeForCalculation,
					selected: product.selected,
				})),
				reference: {
					dosageStrength: update.dosageStrength,
					historicProductDataViewDate:
						update.historicProductDataViewDate !== null ? formatApiDate(update.historicProductDataViewDate) : null,
					packageSize: update.packageSize,
					referenceBasketVersion: update.referenceBasketVersion,
				},
			}),
			method: 'POST',
		});
		const response = await request.json();
		return {
			ltMaxPrice: mapLtMaxPrice(response.ltMaxPrice),
		};
	} catch (error) {
		throw error instanceof ApiClientErrorResponse
			? new ErrorResponse(error.request, error.statusCode, error.errors)
			: error;
	}
};
